module.exports = "./img/d8f98a8c19382de993cef49c83c3edf7.jpg";